import React from 'react';

const Breadcrumb = ({ breadcrumbs = [] }) => {
  return (
    <>
      <span
        onClick={() => {
          if (breadcrumbs[0].event) {
            breadcrumbs[0].event();
          }
        }}
        className={`text-secondary-354 text-sm ${breadcrumbs[0].event && 'cursor-pointer whitespace-nowrap'}`}
      >
        {breadcrumbs[0]?.title}
      </span>
      {breadcrumbs.slice(1).map((breadcrumb, index) => (
        <React.Fragment key={`breadcrumb-${index}`}>
          <span className="text-sm text-black/45">/</span>
          <span className="text-sm text-black-102 break-all line-clamp-1">{breadcrumb?.title}</span>
        </React.Fragment>
      ))}
    </>
  );
};

export default React.memo(Breadcrumb);
